import { useInView } from "../hooks/useIntersectionObserver";

export default function Reveal({ children, className = "", delay = 0, style = {}, as: Tag = "div" }) {
  const [ref, inView] = useInView();
  return (
    <Tag
      ref={ref}
      style={{ transitionDelay: `${delay}ms`, ...style }}
      className={`reveal ${inView ? "in-view" : ""} ${className}`}
    >
      {children}
    </Tag>
  );
}
